export default __webpack_public_path__ + "static/media/plants-label-icon.631ddbe0.svg";